export default class LimitedRelationshipModel {
    id_parentesco: string | null;
    parentesco: string | null;
    limite: number | null;

    constructor(id_parentesco: string | null, parentesco: string | null, limite: number | null) {
        this.id_parentesco = id_parentesco;
        this.parentesco = parentesco;
        this.limite = limite;
    }

    static fromApiResponse(data: any): LimitedRelationshipModel {
        return new LimitedRelationshipModel(
            data.id_parentesco || null,
            data.parentesco || null,
            data.limite || null,
        );
    }

    static fromApiResponseArray(dataArray: any[]): LimitedRelationshipModel[] {
        return dataArray.map(data => LimitedRelationshipModel.fromApiResponse(data));
    }
}
